import * as Sentry from "@sentry/angular";

export function shouldIgnoreSentryError(event: Sentry.Event): boolean {
  const ignoredErrors = [
    {
      type: "InvalidStateError",
      messageIncludes: "document visibility state is hidden",
    },
    {
      type: "InvalidStateError",
      messageIncludes: "Skipping view transition because viewport size changed",
    },
    {
      type: "AbortError",
      messageIncludes: "Old view transition aborted by new view transition",
    },
  ];

  return (
    event.exception?.values?.some((e) =>
      ignoredErrors.some(
        (rule) =>
          e.type === rule.type && e.value?.includes(rule.messageIncludes)
      )
    ) ?? false
  );
}
